import React from 'react';
import ReactDOM from 'react-dom/client';
import TagManager from 'react-gtm-module';
import axios from 'axios';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { clearAuthAndRedirect } from './Component/Common/auth';
// import 'leaflet/dist/leaflet.css';
// import 'moment/locale/en-gb';
// import moment from 'moment';

// moment.locale('en-gb');

const tagManagerArgs = {
  gtmId: 'GTM-PHH2KT'
};

// ─── Suppress CRA dev overlay for cross-origin "Script error." ───────────────
// CRA 5.x installs a window.addEventListener('error', handleError) to power its
// dev overlay. Cross-origin scripts (GTM, Stripe) emit "Script error." with no
// origin info — these are meaningless noise. We patch addEventListener BEFORE
// CRA/GTM run so their handler never sees these opaque events.
if (process.env.NODE_ENV === 'development') {
  const _origAddEventListener = window.addEventListener.bind(window);
  window.addEventListener = function (type, listener, options) {
    if (type === 'error' && typeof listener === 'function') {
      const wrapped = function (event) {
        // Skip cross-origin "Script error." with no useful info
        if (
          event.message === 'Script error.' &&
          !event.filename &&
          event.lineno === 0 &&
          event.colno === 0 &&
          !event.error
        ) {
          return;
        }
        return listener.call(this, event);
      };
      return _origAddEventListener(type, wrapped, options);
    }
    return _origAddEventListener(type, listener, options);
  };

  // Also cover the legacy window.onerror path
  const _origOnError = window.onerror;
  window.onerror = function (message, source, lineno, colno, error) {
    if (message === 'Script error.' && !source && !lineno && !colno && !error) {
      return true;
    }
    if (_origOnError) return _origOnError(message, source, lineno, colno, error);
    return false;
  };
}

// ─── Redirect to login on an expired/invalid auth token ──────────────────────
// ~37 components import the bare `axios` module directly and hand-roll their
// own error handling with no status-code check, so an expired token just
// surfaces the backend's "Unauthenticated or Token Expired." message as a
// toast with no way back to the login page. Registering the interceptor here
// (once, at bootstrap) attaches to axios's shared default instance and
// applies retroactively to every existing call site without touching them.
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const hasToken = !!localStorage.getItem('token');
    if (error.response?.status === 401 && hasToken) {
      clearAuthAndRedirect();
    }
    return Promise.reject(error);
  }
);

TagManager.initialize(tagManagerArgs);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
